import styles from 'styles/views/AppPanel.css';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import _ from '../utils/lodash';
import config from 'config/config_server.json';
import { MODE } from 'constants/mode';
import contextService from 'services/contextService';
import Button from 'views/widgets/Button';
import Events from 'views/Events';
import DefinePageview from 'views/PageviewEvent/DefinePageviewEvent';
import DefineEventIcon from 'views/BaseElements/DefineEventIcon';
import BrowseEventIcon from 'views/BaseElements/BrowseEventIcon';
import { MESSAGE } from 'constants/message';
import { hideHeader, getWinObject } from 'utils/url';
import { wrapFocusIn } from 'views/shared/utils/focusHandler';

export class AppPanel extends Component {
  static propTypes = {
    editorState: PropTypes.object,
    editorStateActions: PropTypes.object,
    events: PropTypes.array.isRequired,
    onDeleteEvent: PropTypes.func.isRequired,
    onEditEvent: PropTypes.func.isRequired,
    onExit: PropTypes.func.isRequired,
    onHighlightEvent: PropTypes.func.isRequired,
    projectId: PropTypes.string,
    pageviewEvents: PropTypes.array,
    // storage: PropTypes.object.isRequired,
    storage: PropTypes.object,
    removePageviewId: PropTypes.func,
    pageviewId: PropTypes.string,
    appPanelHide: PropTypes.bool,
    toggleAppPanelHide: PropTypes.func
  };

  componentDidMount () {
    const body = document.getElementsByTagName('body')[0];
    let {storage} = this.props;
    body.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.keyCode === 75) {
        let mode = this.props.editorState.mode;
        if (!mode) {
          try {
            if (storage.get && typeof storage.get === 'function') {
              mode = storage.get('_aurycMode') || MODE.EDIT;
            } else {
              mode = storage.getByKey('_aurycMode') || MODE.EDIT;
            }
          } catch (err) {
          }
        }
        mode = mode || MODE.EDIT;
        if (mode === MODE.EDIT) {
          this.enterBrowseMode();
        } else {
          this.enterEditorMode();
        }
      }
    });
    wrapFocusIn(this.props.editorState.mode);
    this.removeTabIndex();

    // add a message listener to react to BROWSE/EDIT mode change
    window.addEventListener('message', (event) => {
      const evtData = event.data;
      if (evtData.command && evtData.source && evtData.source === '_ar_') {
        const command = evtData.command;
        if (command === MESSAGE.ENTER_EDIT_MODE) {
          this.enterEditorMode();
        } else if (command === MESSAGE.ENTER_BROWSER_MODE) {
          this.enterBrowseMode();
        }
      }
    });
  }

  removeTabIndex = () => {
    setTimeout(function () {
      if (document.activeElement) {
        document.activeElement.removeAttribute('tabindex');
      }
    }, 1000);
  };

  handlerExit = () => {
    this.props.onExit();
  };

  editEvent = (event) => {
    this.showEventList(false);
    this.props.onEditEvent(event);
  };

  updateLocalStorage = (mode) => {
    const auryc = JSON.parse(localStorage.auryc || '{}');
    auryc._aurycMode = mode;
    localStorage.auryc = JSON.stringify(auryc);
  }

  handleIframe (mode) {
    let frameList = document.querySelectorAll('iframe');
    let {storage} = this.props;
    const hash = storage.getByKey('_originalHash');
    for (let i = 0; i < frameList.length; i++) {
      let fNode = frameList[i];
      let myWin = getWinObject(fNode);
      if (!myWin) {
        return;
      }

      let message = {
        source: '_ar_',
        command: MESSAGE.ENTER_BROWSER_MODE,
        hash: hash
      };

      if (mode === MODE.EDIT) {
        message.command = MESSAGE.ENTER_EDIT_MODE;
      }

      try {
        myWin.postMessage(message, '*');
      } catch (e) {
      }
    }
  }
  enterEditorMode = () => {
    let mode = MODE.EDIT;
    let path ='mode';
    let operation = 'update';
    let {storage} = this.props;

    this.props.editorStateActions.dynamicDispatch(
      Object.assign({params: mode}, {path, operation})
    );
    this.updateLocalStorage(mode);
    if (storage.setSession && typeof storage.setSession === 'function') {
      storage.setSession('_aurycMode', MODE.EDIT);
    } else {
      storage.setSessionByKey('_aurycMode', MODE.EDIT);
    }

    this.removeTabIndex();
    this.handleIframe(mode);
  };

  enterBrowseMode = () => {
    let mode = MODE.BROWSE;
    let path ='mode';
    let operation = 'update';
    let {storage} = this.props;

    this.props.editorStateActions.dynamicDispatch(
      Object.assign({params: mode}, {path, operation})
    );
    this.updateLocalStorage(mode);
    if (storage.setSession && typeof storage.setSession === 'function') {
      storage.setSession('_aurycMode', MODE.BROWSE);
    } else {
      storage.setSessionByKey('_aurycMode', MODE.BROWSE);
    }
    this.handleIframe(mode);
  };

  showEventList = (visible) => {
    let path ='showEventList';
    let operation = 'update';
    this.props.editorStateActions.dynamicDispatch(
      Object.assign({params: visible}, {path, operation})
    );
  };

  render () {
    const {appPanelHide, toggleAppPanelHide} = this.props;
    let logoUrl = `${config.editorUrl}/Auryc_Logo_Color_Light.svg`;
    const pageviewEvent = this.props.pageviewEvents.map(item => ({ attrs: item }));
    const allEvents = this.props.events.concat(pageviewEvent);
    const events = _.sortBy(allEvents, 'attrs.name', 'asc');
    let chevronUp = `${config.editorUrl}/up.svg`;
    let chevronDown = `${config.editorUrl}/down.svg`;

    let className = hideHeader() ? styles.containerIframe: styles.container;
    let toggleClassName = hideHeader() ? styles.hideCollpseController : styles.collpseController;

    return (
      <div id='aurycEditorPanel'>
        <div className={cn(className, {[styles.collpsePanel]: appPanelHide})}>
          <Button className={styles.exitButton} onClick={this.handlerExit}>
            <span
              className={styles.exitIcon}
              style={{marginBottom: 'unset'}}>✕</span>
            <span
              className={styles.h_o_m}
              style={{marginBottom: 'unset'}}>Exit Event Marker</span>
          </Button>
          <div className={styles.left}>
            <div className={styles.logoContainer}>
              <img className={styles.logo} style={{paddingLeft: 10}} src={logoUrl} width='150px' alt='Auryc logo'/>
            </div>
            <p className={cn(styles.hotkey, styles.h_o_m)}>Toggle Shortcut: Ctrl + k</p>
            <div className={styles.modeSelector}>
              <button
                onClick={this.enterEditorMode}
                className={cn(styles.panelButton, styles.Left,
                  {[styles.Active]: this.props.editorState.mode === MODE.EDIT})}>
                <DefineEventIcon/>
                <span style={{marginBottom: 'unset'}}>Define</span>
              </button>
              <button
                className={cn(styles.panelButton, styles.Right,
                  {[styles.Active]: this.props.editorState.mode === MODE.BROWSE})}
                onClick={this.enterBrowseMode}>
                <BrowseEventIcon/>
                <span style={{marginBottom: 'unset'}}>Browse</span>
              </button>
            </div>
          </div>
          <Events
            events={events}
            onEditEvent={this.editEvent}
            onHighlightEvent={this.props.onHighlightEvent}
            onListEvent={this.showEventList}
            onDeleteEvent={this.props.onDeleteEvent}
            visible={this.props.editorState.mode === MODE.EDIT}/>
          <DefinePageview
            projectId={this.props.projectId}
            pageviewId={this.props.pageviewId}
            removePageviewId={this.props.removePageviewId}
            visible={this.props.editorState.mode === MODE.EDIT}/>
        </div>
        <div
          className={cn(toggleClassName, {[styles.collpseControllerHide]: appPanelHide})}
          onClick={toggleAppPanelHide}>
          {appPanelHide ? <img src={chevronDown} alt='chevronDown'/> : <img src={chevronUp} alt='chevronUp'/>}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    storage: contextService.get('storage')
  };
};

export default connect(mapStateToProps, null)(AppPanel);



/** WEBPACK FOOTER **
 ** ./src/views/AppPanel.js
 **/